// Entry point for the build script in your package.json
import React from "react";
import { createRoot } from "react-dom/client";
import components from "./components";
import katex from "katex";
import initScrollSpy from "./lib/scroll_spy";
import initAccordionGroups from "./lib/accordion_group";
import initTestFilter from "./lib/test_filter";
import initDropdowns from "./lib/dropdown";
import initGlossaryPopovers from "./lib/glossary_popover";

// Components marked data-react-lazy (the glossary's many charts) mount when they come within a screen of view.
function mountReactComponents() {
	const lazy = "IntersectionObserver" in window && new IntersectionObserver((entries, observer) => {
		entries.filter((e) => e.isIntersecting).forEach((e) => { observer.unobserve(e.target); mountReactComponent(e.target); });
	}, { rootMargin: "100% 0px" });
	document.querySelectorAll("[data-react-component]").forEach((el) => {
		if (lazy && el.dataset.reactLazy) lazy.observe(el);
		else mountReactComponent(el);
	});
}

function mountReactComponent(el) {
	{
		const name = el.dataset.reactComponent;
		const Component = components[name];

		if (!Component) {
			console.error(`React component "${name}" not found in registry.`);
			return;
		}

		let props = {};
		if (el.dataset.reactProps) {
			try {
				props = JSON.parse(el.dataset.reactProps);
			} catch (e) {
				console.error(`Invalid JSON in data-react-props for "${name}":`, e);
				return;
			}
		}

		const root = createRoot(el);
		root.render(React.createElement(Component, props));
	}
}

function renderMath() {
	document.querySelectorAll("[data-latex]").forEach((el) => {
		katex.render(el.dataset.latex, el, {
			displayMode: el.dataset.display === "block",
			throwOnError: false
		});
	});
}

document.addEventListener("DOMContentLoaded", () => {
	mountReactComponents();
	renderMath();
	initScrollSpy();
	initAccordionGroups();
	initTestFilter();
	initDropdowns();
	initGlossaryPopovers(); // after renderMath, so the definitions it copies have their symbols typeset
});
